module.exports = __webpack_public_path__ + "img/ape-constructor-lootbox-scroll.2ff8f4a8.svg";